export default __webpack_public_path__ + "static/media/image2.08fe5c72.jpg";